module.exports = __webpack_public_path__ + "img/training.930b9412.svg";